<template>
  <div v-if="breadcrumb.length > 0 && breadcrumb[0].name && breadcrumb[0].name !== ''" class="breadcrumb">
    <ul>
      <li>
        <span>
          <router-link to="/">
            <span>CSLobby</span>
          </router-link>
        </span>
      </li>
      <li :key="index" v-for="(item, index) in breadcrumb">
        <span v-if="item.name !== ''">
          <router-link :to="item.link" v-if="item.link !== ''">
            <span>{{ content(item.name) }}</span>
          </router-link>
          <span v-else-if="item.name === 'play'" v-html="content(item.name)"></span>
          <span v-else-if="item.name === 'user'" v-html="content(item.name)"></span>
          <span v-else v-html="data.gather.info.name"></span>
        </span>
      </li>
    </ul>
  </div>
</template>

<script>
import dataStore from '@/helpers/data';
import language from '@/helpers/language';
export default {
  name: 'ComponentCoreHeaderBreadcrumb',
  components: {},
  computed: {
    data() {
      return dataStore.getter(this.$store.getters);
    },
  },
  props: {},
  data() {
    return {
      currentPage: '',
      breadcrumb: [],
    };
  },
  watch: {
    $route(to, from) {
      if (to !== from) {
        let breadcrumb = [];
        to.path
          .substr(1)
          .split('/')
          .forEach((item) => {
            let obj = { name: item, link: '/' + item };
            breadcrumb.push(obj);
          });

        breadcrumb[breadcrumb.length - 1].link = '';
        this.breadcrumb = breadcrumb;
      }
    },
  },
  mounted() {},
  updated() {},
  methods: {
    content(item) {
      return language(this.data.language.current)[item];
    },
  },
};
</script>
